import React from "react";
import usePublicWrapperStyles from "../public-wrapper/public-wrapper.styles";
import footerStyles from "./footer.styles";
import { FCB_PRIVACY_STATEMENT,SVB_ECOA_URL } from "../../utils/urls";
import STATIC_TEXT from "../../content/common.json";
import { toggleConsentBox } from '../../utils/onetrust-utils';
import privacyOptionsIcon from "../../assets/privacy-options.svg";

interface FooterProps {
  footerData?: JSX.Element;
}

export const Footer: React.FC<FooterProps> = ({ footerData }) => {
  const classes = footerStyles();
  const privacyChoiceClicked = (event:React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    toggleConsentBox()
  }
  return (
    <footer className={classes.footerNonMobile}>
      {footerData || (
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={FCB_PRIVACY_STATEMENT}
        >
          {STATIC_TEXT.footer.privacyPolicy}
        </a>
      )}
      {footerData || (
      
        <a
          rel="noopener noreferrer"
          href='#'
          onClick={privacyChoiceClicked}
        >
          {STATIC_TEXT.footer.privacyChoices}
          <img  className={classes.footerPrivacyChoicesImage}  src={privacyOptionsIcon}  />
        </a>
      
      )}
      {footerData || (
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={SVB_ECOA_URL}
        >
          {STATIC_TEXT.footer.ECOADisclosure}
        </a>
      )}
    </footer>
  );
};
